module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/tables-icon-8d23ca0c8145dc75823f513ac2aca743.png";